import { gql } from '@apollo/client'

export const GET_LOGGED_IN_USER_TOUR_RECORD = gql`
  query GetLoggedInUserTourRecord {
    loggedInUser {
      id
      tourRecords {
        id
        skipped
        progress
        tour {
          id
          name
        }
      }
    }
  }
`
